import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import OutlineButton from "../Buttons/OutlineButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import Switch from "../../UI/Switch";

import {
  Box,
  Button,
  ButtonGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import InfoIcon from "@material-ui/icons/Info";
import ListIcon from "@material-ui/icons/List";
import ViewAgendaIcon from "@material-ui/icons/ViewAgenda";
import { Autocomplete } from "@material-ui/lab";
import DescriptionIcon from "@material-ui/icons/Description";
import { setView } from "../../../Stores/Enquiries/actions";
import flexStyles from "../../../style/flex";
import textStyle from "../../../style/typography";
import { useStyles } from "./style";
import SecondaryButton from "../Buttons/SecondaryButton";

const ListingHeader = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const flexClasses = flexStyles();
  const textClasses = textStyle();

  const view = useSelector((state) => state.EnquiriesReducer.view);
  const dispatch = useDispatch();

  const getClass = (filter, index) => {
    let className = classes.listItem;

    if (props?.hasCount) {
      if (
        props?.activeListFilter?.toLowerCase() === filter?.label?.toLowerCase()
      ) {
        className = `${className} ${classes[`bg${index}`]}  ${
          classes.listItemSelected
        }`;
      } else {
        className = `${className} ${classes[`bg${index}`]}`;
      }
    } else {
      if (
        props?.activeListFilter?.toLowerCase() === filter?.label?.toLowerCase()
      ) {
        className = `${className} ${classes.listItemSelected}`;
      }
    }

    if (props?.showTimeline === true) {
      className = `${className} ${classes.fixedItem}`;

      if (index === 6) {
        className = `${className} ${classes.fixedItemLG}`;
      }
    }

    return className;
  };

  return (
    <>
      {props.showProfileTabs !== true && props.hideHeader !== true && (
        <Box className={classes.pageHeaderWrap}>
          <Box className={classes.titleWrap}>
            <Typography
              className={`${textClasses.header1} ${textClasses.semibold}`}
            >
              {props.title}
            </Typography>
            {props?.showTimeline !== true && props?.listfilter?.length > 0 && (
              <Box
                className={`${
                  props?.hasCardActions ||
                  (props.hasYear && flexClasses.flexCenterBetween)
                } ${classes.filterWrap}`}
              >
                <ul className={classes.list}>
                  {props?.listfilter?.length > 0 && (
                    <>
                      {props.listfilter.map((filter, index) => (
                        <li
                          className={getClass(filter, index)}
                          onClick={() => props.onListFilterClick(filter?.label)}
                        >
                          {`${filter?.label}`}
                          {props?.hasCount && index !== 0 && (
                            <span className={classes.listCount}>
                              {`(${props?.stats?.[filter?.count] ?? `0`})`}
                            </span>
                          )}
                        </li>
                      ))}
                    </>
                  )}
                </ul>
              </Box>
            )}
          </Box>
          <Box className={classes.actionWrap}>
            {props.hasTaskToggle === true && (
              <Switch
                label={props?.taskToggleLabel ?? "My Tasks"}
                isFlex={true}
                checked={props.taskToggle}
                onChange={(e) => props.onTaskToggle(e?.target?.checked)}
              />
            )}
            {props?.customContent && props?.customContent}
            {props?.hasYear && (
              <Box
                style={{
                  width: 120,
                  background: "#fff",
                  borderRadius: 6,
                }}
              >
                <Autocomplete
                  id="year-picker"
                  disableClearable={true}
                  options={props?.yearList ?? []}
                  getOptionLabel={(option) => (option ? option.toString() : "")}
                  value={props.year}
                  onChange={(event, newValue) => props?.onYear(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" size="small" />
                  )}
                />
              </Box>
            )}
            {props.hasViewToggle && (
              <Box className={classes.viewWrap}>
                <ButtonGroup color="primary" aria-label="primary button group">
                  <Button
                    variant={view === "default" ? "contained" : "outlined"}
                    onClick={() => dispatch(setView("default"))}
                  >
                    <ListIcon />
                  </Button>
                  <Button
                    variant={view === "card" ? "contained" : "outlined"}
                    onClick={() => {
                      dispatch(setView("card"));
                      props.onViewChange();
                    }}
                  >
                    <ViewAgendaIcon fontSize="small" />
                  </Button>
                </ButtonGroup>
              </Box>
            )}
            {props.hasFilter && (
              <SecondaryButton
                hideIcon={false}
                hasIcon={true}
                icon={<FilterListIcon />}
                onClick={() => (props.hasFilter ? props.onFilterAction() : {})}
              >
                Filters
              </SecondaryButton>
            )}
            {props.hasCsvmodal && (
              <SecondaryButton
                hideIcon={false}
                hasIcon={true}
                icon={<DescriptionIcon />}
                onClick={() => (props.hasCsvmodal ? props.onCsvAction() : {})}
              >
                Upload CSV
              </SecondaryButton>
            )}
            {props.hideAdd !== true && (
              <PrimaryButton
                hideIcon={false}
                onClick={() =>
                  props?.isAddModal
                    ? props?.onAddModal()
                    : history.push(props.redirect)
                }
              >
                {props?.hasAddTitle ? props?.addTitle : props?.title}
              </PrimaryButton>
            )}
            {props?.hasCardActions && (
              <div className={flexClasses.flexCenterGap}>
                <SecondaryButton onClick={() => props?.onCardAction()}>
                  Print Instructions
                </SecondaryButton>
                {props?.hideOrder !== true && (
                  <PrimaryButton
                    variant="primary"
                    hideIcon={true}
                    onClick={() => history.push(`/d/review/packages`)}
                  >
                    {props?.cardActionTitle ?? ""}
                  </PrimaryButton>
                )}
              </div>
            )}
          </Box>
        </Box>
      )}
      {(props.showInfoText || props.showTimeline) && (
        <Box
          className={
            props?.showTimeline
              ? `${classes.timeline} ${classes.timelineClear}`
              : `${classes.timeline}`
          }
        >
          {props?.showInfoText && (
            <Box className={classes.infoWrap}>
              <InfoIcon />
              <Typography>{props?.infoText ?? ``}</Typography>
            </Box>
          )}
          {props.showTimeline && props?.listfilter?.length > 0 && (
            <Box
              className={`${
                props?.hasCardActions ||
                (props.hasYear && flexClasses.flexCenterBetween)
              } ${classes.filterWrap}`}
            >
              <ul className={classes.list}>
                {props?.listfilter?.length > 0 && (
                  <>
                    {props.listfilter.map((filter, index) => (
                      <li
                        className={getClass(filter, index)}
                        onClick={() => props.onListFilterClick(filter?.label)}
                      >
                        {`${filter?.label}`}
                        {props?.hasCount && index !== 0 && (
                          <span className={classes.listCount}>
                            {`(${props?.stats?.[filter?.count] ?? `0`})`}
                          </span>
                        )}
                      </li>
                    ))}
                  </>
                )}
              </ul>
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default memo(ListingHeader);
